import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Container from 'common/src/components/UI/Container';
import Heading from 'reusecore/src/elements/Heading';
import BlogPost from 'common/src/components/BlogPost';
import SectionWrapper, {
  SectionHeader,
  TitleArea,
  LinkArea,
  Text,
  PostArea,
} from './blogSection.style';

const BlogSection = () => {
  const data = useStaticQuery(graphql`
    query {
      charityJson {
        posts {
          id
          thumbUrl {
            publicURL
          }
          title
          excerpt
          btnUrl
          btnText
        }
      }
    }
  `);

  return (
    <SectionWrapper id="blog">
      <Container width="1260px">
        <SectionHeader>
          <TitleArea>
            <Heading content="Partnerlerimiz" />
            <Text>
              Gartner ve <a href="https://www.quanton.co.nz/wp-content/uploads/2019/12/Forrester-Wave-Robotic-Process-Automation-Q4-2019.pdf"  target="_blank" > Forrester (Lütfen raporun 4.sayfadaki grafige bakınız.)
              </a> değerlendirmelerine göre "Leader" konumundaki iki vendor çalışabiliyoruz. Bu kapsamda, müşterilerimizin ihtiyaçları ve tercihlerine uygun biçimde Automotion Anyware ve UIPath ürünlerinden birini kullanarak Otonom iş gücü kazandırıyoruz. 
            </Text>
          </TitleArea>

        </SectionHeader>
        <PostArea>
          {data.charityJson.posts.map(item => (
            <BlogPost
              key={`blog__post-key${item.id}`}
              thumbUrl={item.thumbUrl.publicURL}
              title={item.title}
              excerpt={item.excerpt}
              link={
                <a className="learn__more-btn" href={item.btnUrl}>
                  <span className="hyphen"></span>
                  <span className="btn_text">{item.btnText}</span>
                </a>
              }
            />
          ))}
        </PostArea>
      </Container>
    </SectionWrapper>
  );
};

export default BlogSection;
